import { types } from '../actions/choiceGroup';
var initialState = {};
var choiceGroupsReducer = function (choiceGroups, action) {
    if (choiceGroups === void 0) { choiceGroups = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.SET_CHOICE_GROUP_OPTIONS:
            payload.forEach(function (item) {
                choiceGroups[item.alias] = item;
            });
            return choiceGroups;
        default:
            return choiceGroups;
    }
};
export default choiceGroupsReducer;
//# sourceMappingURL=choiceGroup.js.map